import { IonListHeader } from '@ionic/react'
import { IconChevron } from '../../icons/IconChevron'
import { FC, useState } from 'react'
import { useOutsideClick } from '../../../hooks/useOutsideClick'

interface HomeSectionHeaderComponentProps {
  filterByStatus: (status: string) => void
}

export enum EMenu {
  upcoming,
  past,
  cancelled,
}

const HomeSectionHeaderComponent: FC<HomeSectionHeaderComponentProps> = ({ filterByStatus }) => {
  const [menu] = useState([
    {
      title: 'Upcoming',
      value: 'current',
    },
    {
      title: 'Past',
      value: 'past',
    },
    {
      title: 'Cancelled',
      value: 'cancel',
    },
  ])
  const [activeMenu, setActiveMenu] = useState(EMenu.upcoming)
  const [isSubMenuShown, setIsSubMenuShown] = useState(false)
  const ref = useOutsideClick(() => setIsSubMenuShown(false))

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  return (
    <IonListHeader className="mx-0 z-10 w-full relative overflow-visible box-border px-5">
      <div className="flex flex-wrap justify-between items-center w-full mx-auto gap-2 pb-4">
        <div className="p-0 flex  flex-1 text-[15px] text-SeabiscuitDark200ThemeColor relative">
          <div
            ref={ref}
            className={
              'flex items-center  gap-3 font-bold cursor-pointer hover:opacity-80 transition-all'
            }
            onClick={() => setIsSubMenuShown(true)}
          >
            <span>{menu[activeMenu].title} events</span>
            <span className={isSubMenuShown ? 'rotate-180' : ''}>
              <IconChevron />
            </span>
          </div>

          {isSubMenuShown && (
            <div
              className={
                'absolute top-[100%] rounded border border-[#D3DAEE] p-2 overflow-hidden mr-[-10px] left-0 flex flex-col bg-white min-w-[200px]'
              }
            >
              {menu.map((itm, i) => {
                if (activeMenu === i) {
                  return <></>
                }
                return (
                  <button
                    className={'text-left font-normal py-1 px-2 hover:bg-[#F6F7FB] rounded'}
                    onClick={() => {
                      setActiveMenu(i)
                      filterByStatus(menu[i].value.toLowerCase())
                      setIsSubMenuShown(false)
                    }}
                    key={itm.value + i}
                  >
                    {itm.title} events
                  </button>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </IonListHeader>
  )
}

export default HomeSectionHeaderComponent
